// LojasTable.js
import {
  Alert,
  Button,
  Chip,
  IconButton,
  InputAdornment,
  Link,
  Snackbar,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import {
  Edit,
  Send,
  Close,
  FilterAlt,
  Directions,
  AttachFile,
  SaveOutlined,
  Quiz,
  FileDownload,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import useGetReversalInfos from "../../../hooks/reversal/useGetReversalInfos";
import React from "react";
import AutoCompleteCustom from "../../../components/AutoCompleteCustom";
import useReplaceForm from "../../../hooks/reversal/useReplaceForm";
import dayjs from "dayjs";
import DataGridCustom from "../../../components/DataGridCustom";
import Grid from "@mui/material/Unstable_Grid2";
import {
  GridColDef,
  GridColumnVisibilityModel,
  GridRowParams,
  GridRowSelectionModel,
} from "@mui/x-data-grid";
import useEndCase from "../../../hooks/reversal/useEndCase";
import useSaveAddaForm from "../../../hooks/reversal/useSaveAdda";
import useBatchSaveAddaForm from "../../../hooks/reversal/useBatchSaveAdda";
import ExportDialog from "./DialogFilterExport";
import { useFormatString } from "../../../utils/useFormatString";
import LoadingButton from "@mui/lab/LoadingButton";
import { RequestData } from "../../../hooks/reversal/useGetAllReversal";
import { useFormDialog } from "../../../hooks/useFormDialog";
import ChangeTextTableDialog from "./ChangeTextTableDialog";
interface TableComponentProps {
  data: RequestData[];
  loading: boolean;
  refresh: () => void;
  rowCountState: number;
  paginationModel: any;
  setPaginationModel: (paginationModel: any) => void;
  gridApiRef: any;
  handleExport: (event: any) => void;
}

const TableComponent = (props: TableComponentProps) => {
  const navigate = useNavigate();
  const [data, setData] = useState<RequestData[]>(props.data);
  useEffect(() => {
    if (props.data) {
      setData(props.data);
    }
  }, [props.data]);
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [motive, setMotive] = useState<string | null>(null);
  const { updateFormArea } = useReplaceForm();
  const { updateMultiFaqTable } = useBatchSaveAddaForm();
  const { endCaseByIdHooks } = useEndCase();
  const [comment, setComment] = useState<string>("");
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [messages, setMessages] = useState("");
  const { formatPhone } = useFormatString();
  const { data: dataFaq } = useGetReversalInfos("CÉLO/15");
  const { data: cancelMotiveData } = useGetReversalInfos("OQACSP");
  const { data: pedidosData } = useGetReversalInfos("PEREVI");
  const [datafaqFilter, setDataFaqFilter] = useState<any[]>(dataFaq);
  const [profilesToSelect, setProfilesToSelect] = useState<any>();
  const [multiEstorno, setMultiEstorno] = useState<any>();
  const [multiFaq, setMultiFaq] = useState<any>();
  const [disabledFaqRP, setDisabledFaqRP] = useState<boolean>(false);
  const profileUser = localStorage.getItem("profile");
  const loginUser = localStorage.getItem("Login");
  const { updateFormTable } = useSaveAddaForm();

  const sendTotherArea = () => {
    const updatedData = {
      queue: motive,
      items: rowSelectionModel.map((idCase) => ({
        id: idCase,
        comment: comment,
      })),
    };
    updateFormArea(updatedData).then((resp: any) => {
      if (resp?.status === 200) {
        setOpenSuccess(true);
        setMessages("Envio para área finalizado!");
        props.refresh();
      } else {
        setOpenError(true);
        setMessages("Erro ao enviar para outra área!");
      }
    });
  };

  const sendMultiFaqForm = () => {
    const updatedData = {
      perfil: profileUser,
      faq: multiFaq,
      estornado: multiEstorno,
      login: loginUser,
      items: rowSelectionModel.map((idCase) => ({
        id: idCase,
      })),
    };
    updateMultiFaqTable(updatedData).then((resp: any) => {
      if (resp?.status === 200) {
        setOpenSuccess(true);
        setMessages("Salvo com Sucesso!");
        props.refresh();
      } else {
        setOpenError(true);
        setMessages("Erro ao Salvar");
      }
    });
  };
  const encerrarCaso = () => {
    const updatedData = {
      items: rowSelectionModel.map((idCase) => ({
        id: idCase,
        comment: comment,
      })),
    };

    endCaseByIdHooks(updatedData).then((resp: any) => {
      if (resp.status === 200) {
        setOpenSuccess(true);
        setMessages("Encerramento de caso realizado com sucesso!");
        props.refresh();
      } else {
        setOpenError(true);
        setMessages("Erro ao encerrar caso!");
      }
    });
  };

  const choosenMultiRP = (event: any) => {
    setMultiEstorno(event);
    if (event === "Sim") {
      setDataFaqFilter(dataFaq);
      setMultiFaq("1848");
      setDisabledFaqRP(true);
    } else {
      setMultiFaq("");
      setDisabledFaqRP(false);
      setDataFaqFilter(dataFaq.filter((resp) => resp.idBRAN !== "1848"));
    }
  };

  useEffect(() => {
    if (data) {
      dayjs();
      const initialFaqValues: { [key: number]: string } = {};
      const initialReversalMotiveValues: { [key: number]: string } = {};
      const initialReversalValues: { [key: number]: string } = {};

      data?.forEach((item: any) => {
        initialFaqValues[item.idCase] = item.formInfo.faq || "";
        initialReversalMotiveValues[item.idCase] =
          item.formInfo.motivoEstorno || "";
        initialReversalValues[item.idCase] = item.formInfo.estorno || "";
      });
    }
  }, [data]);
  const handleInfoClick = (item: any) => {
    if (item) {
      const sendForm = {
        perfil: profileUser,
        idCase: item.idCase,
        faq: item.formInfo.faq,
        estornado: item.formInfo.estornado,
        motivoEstorno: item.formInfo.motivoEstorno,
        financeiro: item.formInfo.financeiro,
        login: loginUser
      };

      updateFormTable(sendForm).then((resp) => {
        props.refresh();
      });
    }
  };
  useEffect(() => {
    if (profileUser === "ADMIN") {
      setProfilesToSelect([
        {
          label: "N1-Atendimento",
          id: "N1",
        },
        {
          label: "Franqueado",
          id: "FR",
        },
      ]);
    }
    if (profileUser === "N1") {
      setProfilesToSelect([
        {
          label: "Franqueado",
          id: "FR",
        },
      ]);
    }
    if (profileUser === "N2") {
      setProfilesToSelect([
        {
          label: "N3-CTR",
          id: "N3",
        },
        {
          label: "N1-Atendimento",
          id: "N1",
        },
      ]);
    }
    if (profileUser === "N3") {
      setProfilesToSelect([
        {
          label: "N2-Auditoria",
          id: "N2",
        },
        {
          label: "N1",
          id: "N1",
        },
      ]);
    }
    if (profileUser === "FR") {
      setProfilesToSelect([
        {
          label: "N1-Atendimento",
          id: "N1",
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [rowSelectionModel, setRowSelectionModel] =
    useState<GridRowSelectionModel>([]);

  const handleFinanceiroChange = useCallback((idCase: any, newValue: any) => {
    setData((prevRows) =>
      prevRows.map((row) =>
        row.idCase === idCase
          ? { ...row, formInfo: { ...row.formInfo, financeiro: newValue } }
          : row
      )
    );
  }, []);

  const [isOpenTextChange, titleTextChange, openTextChange, closeTextChange] =
    useFormDialog();

  const [idCase, setIdCase] = useState<number>(0);
  const [text, setText] = useState<string>("");

  const columnsNormal: GridColDef[] = [
    {
      field: "idCase",
      headerName: "ID_FORMULARIO",
      hideable: true,
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => params.row.idCase,
    },
    {
      field: "nameClient",
      minWidth: 100,
      headerName: "NOME COMPLETO",
      flex: 1,

      valueGetter: (params) => params.row.clientInfo.nameClient,
    },
    {
      field: "phoneClient",
      headerName: "TELEFONE",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => formatPhone(params.row.clientInfo.phoneClient),
    },
    {
      field: "emailClient",
      headerName: "EMAIL",
      flex: 1,
      minWidth: 200,
      valueGetter: (params) => params.row.clientInfo.email,
    },
    {
      field: "motivo",
      headerName: "MOTIVO DA SOLICITAÇÃO",

      flex: 1,
      minWidth: 100,
      valueGetter: (params) => {
        const value =
          cancelMotiveData.find(
            (f) => f.idBRAN === params.row.formInfo.oqueAconteceuComSeuPedido
          )?.label ?? "-";
        const padrao: RegExp = / --(.+)/;
        let primeiroCampo: string = "";
        const correspondencias: RegExpMatchArray | null = value.match(padrao);
        if (correspondencias && correspondencias.length > 1) {
          primeiroCampo = correspondencias[1];
        }
        return primeiroCampo ?? "-";
      },
    },
    {
      field: "emQueDataOPedidoFoiFeito",
      headerName: "DATA DO PEDIDO",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        dayjs(params.row.formInfo.emQueDataOPedidoFoiFeito).format(
          "DD/MM/YYYY"
        ),
    },
    {
      field: "numeroDoPedido",
      headerName: "NÚMERO DO PEDIDO",
      flex: 1,
      minWidth: 100,

      valueGetter: (params) => params.row.formInfo.numeroDoPedido,
    },
    {
      field: "emQualLojaOSeuPedidoFoiFeito",
      headerName: "LOJA",
      flex: 1,
      minWidth: 100,

      valueGetter: (params) =>
        params.row.formInfo.emQualLojaOSeuPedidoFoiFeito.split(" -")[0],
    },
    {
      field: "franqueado",
      headerName: "FRANQUEADA?",
      flex: 1,
      minWidth: 100,

      valueGetter: (params) =>
        params.row.formInfo.franqueado > 0 ? "Sim" : "Não",
    },
    {
      field: "problemaPedido",
      headerName: "QUAL PROBLEMA DO PEDIDO?",
      flex: 1,
      minWidth: 100,

      valueGetter: (params) =>
        params.row.formInfo.qualFoiOProblemaComOSeuPedido,
    },

    {
      field: "informeOValorASerEstornado",
      headerName: "VALOR ESTORNADO",
      flex: 1,
      minWidth: 100,

      valueGetter: (params) => params.row.formInfo.informeOValorASerEstornado,
    },
    {
      field: "faltaTrocaPedido",
      headerName: "QUAL ITEM FALTOU OU FOI ENVIADO INCORRETAMENTE?",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => params.row.formInfo.faltaTrocaPedido,
    },
    {
      field: "pedido",
      headerName: "PEDIDO REALIZADO",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => {
        const value = pedidosData.find(
          (f) => f.idBRAN === params.row.formInfo.pedido
        )?.label;
        return value?.split(" – ")[value?.split(" - ").length] ?? value;
      },
    },
    {
      field: "anexoNF",
      headerName: "ANEXO DA NOTA FISCAL",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        `https://arcosdorados.teleperformance.com.br/arcosdoradosapp/reversalDownload/${params.row.idCase}/Nota`,
      renderCell: (params) => {
        return (
          <Link
            href={`/arcosdoradosapp/reversalDownload/${params.row.idCase}/Nota`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Nota: {params.row.idCase}
          </Link>
        );
      },
    },
    {
      field: "anexoPedido",
      headerName: "ANEXO DO PEDIDO",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        `https://arcosdorados.teleperformance.com.br/arcosdoradosapp/reversalDownload/${params.row.idCase}/Pedido`,
      renderCell: (params) => {
        return (
          <Link
            href={`/arcosdoradosapp/reversalDownload/${params.row.idCase}/Pedido`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Pedido: {params.row.idCase}
          </Link>
        );
      },
    },

    {
      field: "estornado",
      headerName: "ESTORNADO",
      flex: 1,
      minWidth: 180,

      valueGetter: (params) => params.row.formInfo.estornado,
      renderCell: (params) => {
        return (
          <AutoCompleteCustom
            hiddenLabel
            disabled={
              params.row.formInfo.estornado === "Sim" &&
              params.row.formInfo.dataFaq !== "0001-01-01T00:00:00"
            }
            onChange={(event: any) => {
              if (event) {
                params.row.formInfo.estornado = event;
                if (event === "Sim") {
                  params.row.formInfo.motivoEstorno = "ES";
                  params.row.formInfo.faq = "1848";
                  setDataFaqFilter(dataFaq);
                } else {
                  params.row.formInfo.motivoEstorno = "NÃES";
                  params.row.formInfo.faq = "";
                  setDataFaqFilter(
                    dataFaq.filter((resp) => resp.idBRAN !== "1848")
                  );
                }
              }
            }}
            options={[
              { id: "Pendente", label: "Pendente" },
              { id: "Sim", label: "Sim" },
              { id: "Não", label: "Não" },
            ]}
            value={params.row.formInfo.estornado}
            field="label"
            variant="filled"
            size="small"
          />
        );
      },
    },
    {
      field: "financeiro",
      headerName: "COD_AUT",
      flex: 1,
      minWidth: 180,
      valueGetter: (params) => params.row.formInfo.financeiro,
      renderCell: (params) => {
        return (
          <TextField
            hiddenLabel
            value={params.row.formInfo.financeiro}
            InputProps={{
              readOnly:true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    color="info"
                    onClick={() => {
                      setIdCase(params.row.idCase);
                      setText(params.row.formInfo.financeiro);
                      openTextChange("COD AUT");
                    }}
                    size="small"
                  >
                    <Edit />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            variant="filled"
            size="small"
          />
        );
      },
    },
    {
      field: "faq",
      headerName: "ID_FAQ",
      flex: 1,
      minWidth: 180,
      valueGetter: (params) =>
        dataFaq.find((f) => f.idBRAN === params.row.formInfo.faq)?.label ?? "-",
      renderCell: (params) => {
        return (
          <AutoCompleteCustom
            disabled={params.row.formInfo.faq === "1848"}
            hiddenLabel
            onChange={(event: any) => {
              params.row.formInfo.faq = event;
            }}
            options={
              params.row.formInfo.faq === "1848"
                ? dataFaq
                : dataFaq.filter((res) => res.idBRAN !== "1848") ?? []
            }
            value={params.row.formInfo.faq}
            field="label"
            variant="filled"
            size="small"
            fieldId="idBRAN"
          />
        );
      },
    },
    {
      field: "loginUser",
      headerName: "ATUALIZADO POR",
      flex: 1,
      minWidth: 100,

      valueGetter: (params) =>
        params.row.formInfo.loginUser ? params.row.formInfo.loginUser : '-',
    },
    {
      field: "dataForm",
      headerName: "DATA DO FORMULÁRIO",
      flex: 1,
      minWidth: 100,

      valueGetter: (params) =>
        dayjs(params.row.formInfo.dataForm).format("DD/MM/YYYY"),
    },
    {
      field: "email",
      headerName: "EMAIL ENVIADO?",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        params.row.formInfo.dataFaq !== "0001-01-01T00:00:00" ? "Sim" : "Não",
    },
    {
      field: "dataFaq",
      headerName: "DATA DO EMAIL",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        params.row.formInfo.dataFaq &&
        dayjs(params.row.formInfo.dataFaq).format("DD/MM/YYYY"),
    },
    {
      field: "actions",
      headerName: "Opções",
      sortable: false,
      filterable: false,
      disableExport: true,
      headerAlign: "center",
      align: "center",
      description:
        "Esta coluna tem um renderCell de valor e não pode ser classificada ou filtrada.",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            <Tooltip title="Salvar">
              <IconButton
                color="success"
                onClick={() => handleInfoClick(params.row)}
              >
                <SaveOutlined />
              </IconButton>
            </Tooltip>
            <Tooltip title="Editar">
              <IconButton
                color="info"
                onClick={() =>
                  navigate(`/reversal-details`, {
                    state: {
                      id: params.row.idCase,
                      origin: false,
                    },
                  })
                }
              >
                <Edit />
              </IconButton>
            </Tooltip>
            <Tooltip title="Formulário Original">
              <IconButton
                style={{ color: "#FFC72C" }}
                onClick={() =>
                  navigate(`/reversal-details`, {
                    state: {
                      id: params.row.idCase,
                      origin: true,
                    },
                  })
                }
              >
                <AttachFile />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    },
  ];

  const adminColumns: GridColDef[] = [
    {
      field: "campoDinamico",
      headerName: " Fila do caso",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => params.row.formInfo.fila ?? "-",
    },
  ];
  const columns = [
    ...columnsNormal,
    ...(profileUser === "ADMIN" ? adminColumns : []),
  ];

  const columns2: GridColDef[] = [
    {
      field: "idCase",
      headerName: "ID_FORMULARIO",
      hideable: true,
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => params.row.idCase,
    },
    {
      field: "nameClient",
      headerName: "NOME COMPLETO",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => params.row.clientInfo.nameClient,
    },
    {
      field: "phoneClient",
      headerName: "TELEFONE DO CLIENTE",
      flex: 1,
      minWidth: 100,

      valueGetter: (params) => params.row.clientInfo.phoneClient,
    },
    {
      field: "emailClient",
      headerName: "EMAIL DO CLIENTE",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => params.row.clientInfo.email,
    },
    {
      field: "motivo",
      headerName: "MOTIVO DA SOLICITAÇÃO",

      flex: 1,
      minWidth: 100,
      valueGetter: (params) => {
        const value =
          cancelMotiveData.find(
            (f) => f.idBRAN === params.row.formInfo.oqueAconteceuComSeuPedido
          )?.label ?? "-";
        const padrao: RegExp = / --(.+)/;
        let primeiroCampo: string = "";
        const correspondencias: RegExpMatchArray | null = value.match(padrao);
        if (correspondencias && correspondencias.length > 1) {
          primeiroCampo = correspondencias[1];
        }
        return primeiroCampo ?? "-";
      },
    },
    {
      field: "emQueDataOPedidoFoiFeito",
      headerName: "DATA DO PEDIDO",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        dayjs(params.row.formInfo.emQueDataOPedidoFoiFeito).format(
          "DD/MM/YYYY"
        ),
    },
    {
      field: "numeroDoPedido",
      headerName: "NÚMERO DO PEDIDO",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => params.row.formInfo.numeroDoPedido,
    },
    {
      field: "emQualLojaOSeuPedidoFoiFeito",
      headerName: "LOJA",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        params.row.formInfo.emQualLojaOSeuPedidoFoiFeito.split("-")[0],
    },
    {
      field: "franqueado",
      headerName: "FRANQUEADA?",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        params.row.formInfo.franqueado > 0 ? "Sim" : "Não",
    },
    {
      field: "problemaPedido",
      headerName: "QUAL PROBLEMA DO PEDIDO?",
      flex: 1,
      minWidth: 100,

      valueGetter: (params) =>
        params.row.formInfo.qualFoiOProblemaComOSeuPedido,
    },
    {
      field: "informeOValorASerEstornado",
      headerName: "VALOR ESTORNADO",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => params.row.formInfo.informeOValorASerEstornado,
    },
    {
      field: "faltaTrocaPedido",
      headerName: "QUAL ITEM FALTOU OU FOI ENVIADO INCORRETAMENTE?",
      flex: 1,
      minWidth: 100,

      valueGetter: (params) => params.row.formInfo.faltaTrocaPedido,
    },
    {
      field: "pedido",
      headerName: "PEDIDO REALIZADO",
      flex: 1,
      minWidth: 100,

      valueGetter: (params) => {
        const value = pedidosData.find(
          (f) => f.idBRAN === params.row.formInfo.pedido
        )?.label;
        return value?.split(" – ")[value?.split(" - ").length] ?? value;
      },
    },
    {
      field: "anexoNF",
      headerName: "ANEXO DA NOTA FISCAL",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        `${window.location.href}/arcosdoradosapp/reversalDownload/${params.row.idCase}/Nota`,
      renderCell: (params) => {
        return (
          <Link
            href={`/arcosdoradosapp/reversalDownload/${params.row.idCase}/Nota`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Nota: {params.row.idCase}
          </Link>
        );
      },
    },
    {
      field: "anexoPedido",
      headerName: "ANEXO DO PEDIDO",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        `${window.location.href}/arcosdoradosapp/reversalDownload/${params.row.idCase}/Pedido`,
      renderCell: (params) => {
        return (
          <Link
            href={`/arcosdoradosapp/reversalDownload/${params.row.idCase}/Pedido`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Pedido: {params.row.idCase}
          </Link>
        );
      },
    },
    {
      field: "estornado",
      headerName: "ESTORNADO",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => params.row.formInfo.estornado,
    },
    {
      field: "qualFoiOProblemaComOSeuPedido",
      headerName: "MOTIVO_ESTORNO",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        params.row.formInfo.qualFoiOProblemaComOSeuPedido,
    },
    {
      field: "faq",
      headerName: "FAQ",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        dataFaq.find((f) => f.idBRAN === params.row.formInfo.faq)?.label ?? "-",
    },
    {
      field: "loginUser",
      headerName: "ATUALIZADO POR",
      flex: 1,
      minWidth: 100,

      valueGetter: (params) =>
        params.row.formInfo.loginUser ? params.row.formInfo.loginUser : '-',
    },
    {
      field: "dataForm",
      headerName: "DATA DO FORMULÁRIO",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        dayjs(params.row.formInfo.dataForm).format("DD/MM/YYYY"),
    },
    {
      field: "email",
      headerName: "EMAIL_ENVIADO",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        params.row.formInfo.faq !== "-" ? "Sim" : "Não",
    },
    {
      field: "dataFaq",
      headerName: "DATA DO EMAIL",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        params.row.formInfo.dataFaq &&
        dayjs(params.row.formInfo.dataFaq).format("DD/MM/YYYY"),
    },
    {
      field: "actions",
      headerName: "Opções",
      sortable: false,
      filterable: false,
      disableExport: true,
      headerAlign: "center",
      align: "center",
      description:
        "Esta coluna tem um renderCell de valor e não pode ser classificada ou filtrada.",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            <Tooltip title="Editar">
              <IconButton
                color="info"
                onClick={() =>
                  navigate(`/reversal-details`, {
                    state: {
                      id: params.row.idCase,
                      origin: false,
                    },
                  })
                }
              >
                <Edit />
              </IconButton>
            </Tooltip>
            <Tooltip title="Formulário Original">
              <IconButton
                style={{ color: "#FFC72C" }}
                onClick={() =>
                  navigate(`/reversal-details`, {
                    state: {
                      id: params.row.idCase,
                      origin: true,
                    },
                  })
                }
              >
                <AttachFile />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    },
  ];

  useEffect(() => {
    const getStorage = localStorage.getItem("columnsFilter");
    let formatColumns;
    if (getStorage && getStorage.trim() !== "") {
      try {
        formatColumns = JSON.parse(getStorage);
      } catch (error) {
        console.error("Erro ao fazer o parse da string JSON:", error);
      }
    }

    setColumnVisibilityModel(formatColumns);
  }, []);
  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({
      idCase: false,
    });
  const setColumnsFilter = (event: any) => {
    setColumnVisibilityModel(event);
    localStorage.setItem("columnsFilter", JSON.stringify(event));
  };

  return (
    <React.Fragment>
      {rowSelectionModel?.length > 0 && (
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid xs={12} md={12} lg={12} xl={12}>
            <Chip
              icon={<Directions color="warning" />}
              label="Envio para Área e Encerramento de caso"
            />
          </Grid>
          <Grid xs={12} md={12} lg={12} xl={12}>
            <Stack
              direction="row"
              justifyItems="center"
              alignItems="center"
              spacing={2}
            >
              <AutoCompleteCustom
                title="Enviar Para Área"
                onChange={(event: any) => setMotive(event)}
                options={profilesToSelect}
                value={motive}
                field="label"
                variant="filled"
              />
              <Button
                startIcon={<Send />}
                onClick={() => sendTotherArea()}
                sx={{ minWidth: 200, minHeight: 56 }}
              >
                Enviar Para Área
              </Button>
              {profileUser !== "FR" && (
                <Button
                  startIcon={<Close />}
                  onClick={() => encerrarCaso()}
                  color="error"
                  sx={{ minWidth: 200, minHeight: 56 }}
                >
                  Encerrar Caso
                </Button>
              )}
            </Stack>
          </Grid>
          <Grid xs={12} md={12} lg={12} xl={12}>
            <TextField
              multiline
              minRows={4}
              inputProps={{
                maxLength: "500",
              }}
              helperText={`${comment.length}/500`}
              label="Observação"
              variant="filled"
              fullWidth
              name="Observação"
              value={comment}
              onChange={(event) => {
                setComment(event.target.value);
              }}
            />
          </Grid>
          <Grid xs={12} md={12} lg={12} xl={12}>
            <Chip icon={<Quiz color="warning" />} label="Envio de FAQ" />
          </Grid>
          <Grid xs={12} md={12} lg={12} xl={12}>
            <Stack
              direction="row"
              justifyItems="center"
              alignItems="center"
              spacing={2}
            >
              <AutoCompleteCustom
                title="ESTORNADO?"
                onChange={(event: any) => {
                  if (event) {
                    choosenMultiRP(event);
                  }
                }}
                options={[
                  { id: "Sim", label: "Sim" },
                  { id: "Não", label: "Não" },
                ]}
                value={multiEstorno}
                field="label"
                variant="filled"
                size="small"
              />
              <AutoCompleteCustom
                disabled={disabledFaqRP}
                title="FAQ"
                onChange={(event: any) => {
                  setMultiFaq(event);
                }}
                options={datafaqFilter ?? []}
                value={multiFaq}
                field="label"
                variant="filled"
                size="small"
                fieldId="idBRAN"
              />
              <Button
                startIcon={<Send />}
                onClick={() => sendMultiFaqForm()}
                sx={{ minWidth: 200, minHeight: 56 }}
              >
                Salvar
              </Button>
            </Stack>
          </Grid>
        </Grid>
      )}
      <Snackbar
        autoHideDuration={6000}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        open={openSuccess}
        onClose={() => setOpenSuccess(false)}
        key={"success"}
      >
        <Alert
          onClose={() => setOpenSuccess(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {messages}
        </Alert>
      </Snackbar>
      <Snackbar
        autoHideDuration={6000}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        open={openError}
        onClose={() => setOpenError(false)}
        key={"error"}
      >
        <Alert
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {messages}
        </Alert>
      </Snackbar>
      {profileUser !== "GECR" && (
        <DataGridCustom
          isReversal={true}
          rows={data}
          getRowId={(row: any) => row.idCase}
          rowCountState={props.rowCountState}
          paginationModel={props.paginationModel}
          setPaginationModel={props.setPaginationModel}
          columns={columns}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={setColumnsFilter}
          loading={props.loading}
          pageSize={20}
          headerHeight={100}
          checkboxSelection
          isRowSelectable={(params: GridRowParams) =>
            params.row.formInfo.estornado !== null ||
            params.row.formInfo.estornado !== "Sim"
          }
          onRowSelectionModelChange={(newRowSelectionModel) => {
            setRowSelectionModel(newRowSelectionModel);
            if (newRowSelectionModel.length === 0) {
              setMotive("");
            }
          }}
          rowSelectionModel={rowSelectionModel}
          gridApiRef={props.gridApiRef}
          customButton={
            <>
              <Button
                startIcon={<FilterAlt />}
                size="small"
                onClick={() => setExportDialogOpen(true)}
              >
                Filtro para Exportar
              </Button>
              <LoadingButton
                startIcon={<FileDownload />}
                loadingPosition="start"
                size="small"
                loading={props.loading}
                onClick={(event) => {
                  props.handleExport(event);
                }}
              >
                Exportar
              </LoadingButton>
            </>
          }
        />
      )}

      {profileUser === "GECR" && (
        <Grid xs={12} md={12} lg={12} xl={12}>
          <DataGridCustom
            isReversal={true}
            rows={data}
            rowCountState={props.rowCountState}
            paginationModel={props.paginationModel}
            setPaginationModel={props.setPaginationModel}
            getRowId={(row: any) => row.idCase}
            columns={columns2}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={setColumnsFilter}
            loading={props.loading}
            pageSize={20}
            headerHeight={120}
            isRowSelectable={(params: GridRowParams) =>
              params.row.formInfo.estornado !== null ||
              params.row.formInfo.estornado !== "Sim"
            }
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setRowSelectionModel(newRowSelectionModel);
              if (newRowSelectionModel.length === 0) {
                setMotive("");
              }
            }}
            rowSelectionModel={rowSelectionModel}
          />
        </Grid>
      )}

      <ExportDialog
        open={exportDialogOpen}
        onClose={() => setExportDialogOpen(false)}
        columns={columns}
      />
      <ChangeTextTableDialog
        title={titleTextChange}
        isOpen={isOpenTextChange}
        idCase={idCase}
        text={text}
        close={closeTextChange}
        save={(newValue: any) => {
          handleFinanceiroChange(idCase, newValue);
          closeTextChange();
          setIdCase(0);
          setText("");
        }}
      />
    </React.Fragment>
  );
};
export default TableComponent;
